<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
            text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
            <template v-if="roleid!='4' &&roleid!='5'" v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                    {{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>

                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>

                        <span slot="title">
                            <span v-if="item.title==='订单管理'"> {{ item.title }}<span v-if="$store.state.isAcitve!=0"
                                    class="dot">{{$store.state.isAcitve}}</span></span>
                            <span v-else>{{ item.title }}</span>
                        </span>

                    </el-menu-item>

                </template>
            </template>
            <template v-if="roleid=='4'" v-for="item in items1">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                    {{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
            <template v-if="roleid=='5'" v-for="item in items2">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                    {{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">
                            <span v-if="item.title==='订单管理'"> {{ item.title }}<span v-if="$store.state.isAcitve!=0"
                                    class="dot">{{$store.state.isAcitve}}</span></span>
                            <span v-else>{{ item.title }}</span>
                        </span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';
    import {
        post
    } from '../../api/request.js'
    import Stroe from '../../store/store.js'
    export default {

        data() {
            return {
                roleid: '',
                collapse: false,
                items1: [{
                    icon: 'el-icon-lx-home',
                    index: 'dashboardNext',
                    title: '商户首页'
                }, {
                    icon: 'el-icon-bank-card',
                    index: 'applyWithdrawal',
                    title: '申请提现'
                }, {
                    icon: 'el-icon-document-checked',
                    index: 'fiSealApply',
                    title: '公章订单',
                }, {
                    icon: 'el-icon-s-grid',
                    index: 'financeCode',
                    title: '二维码',
                }, {
                    icon: 'el-icon-user',
                    index: 'finiceUser',
                    title: '旗下用户',
                }, {
                    icon: 'el-icon-setting',
                    index: 'setword',
                    title: '设置',

                }],
                items2: [{
                        icon: 'el-icon-lx-home',
                        index: 'dashboardNext',
                        title: '商户首页'
                    },
                    {
                        icon: 'el-icon-chat-line-round',
                        title: '公告管理',
                        index: '1',
                        subs: [{
                                index: 'notice',
                                title: '企业公告'
                            }, {
                                index: 'companyInfo',
                                title: '企业动态'
                            },
                            {
                                index: 'companyIntro',
                                title: '企业简介'
                            }, {
                                index: 'noticeCate',
                                title: '关于我们'
                            }
                        ]
                    },

                    {
                        icon: 'el-icon-coordinate',
                        index: '2',
                        title: '公章管理',
                        subs: [{
                                index: 'company',
                                title: '公司类别管理'
                            }, {
                                index: 'sealCate',
                                title: '公章类别管理'
                            },
                            {
                                index: 'seal',
                                title: "公章"
                            }
                        ]
                    }, {
                        icon: 'el-icon-document-checked',
                        index: '4',
                        title: '公章申请管理',
                        subs: [{
                                index: 'applyReason',
                                title: '公章申请理由管理',
                            },
                            {
                                icon: 'el-icon-lx-home',
                                index: 'sealArea',
                                title: '公章申请区域管理',
                            },

                        ]
                    },

                    {
                        icon: 'el-icon-monitor',
                        index: '6',
                        title: '轮播图管理',
                        subs: [{
                            index: 'advertPosition',
                            title: '首页轮播图'
                        }, {
                            index: 'advert',
                            title: '订单页轮播图'
                        }]
                    },
                    {
                        icon: 'el-icon-document-checked',
                        index: 'sealApply',
                        title: '订单管理',
                    },
                ],
                items: [{
                        icon: 'el-icon-lx-home',
                        index: 'dashboardNext',
                        title: '商户首页'
                    },
                    {
                        icon: 'el-icon-chat-line-round',
                        title: '公告管理',
                        index: '1',
                        subs: [{
                                index: 'notice',
                                title: '企业公告'
                            }, {
                                index: 'companyInfo',
                                title: '企业动态'
                            },
                            {
                                index: 'companyIntro',
                                title: '企业简介'
                            }, {
                                index: 'noticeCate',
                                title: '关于我们'
                            }
                        ]
                    },

                    {
                        icon: 'el-icon-coordinate',
                        index: '2',
                        title: '公章管理',
                        subs: [{
                                index: 'company',
                                title: '公司类别管理'
                            }, {
                                index: 'sealCate',
                                title: '公章类别管理'
                            },
                            {
                                index: 'seal',
                                title: "公章"
                            }
                        ]
                    }, {
                        icon: 'el-icon-user',
                        index: '3',
                        title: '人员管理',
                        subs: [{
                                index: 'worker',
                                title: '员工管理'
                            },
                            {
                                index: 'userAddress',
                                title: '用户地址管理'
                            }, {
                                index: 'user',
                                title: '用户管理'
                            },

                        ]
                    }, {
                        icon: 'el-icon-document-checked',
                        index: '4',
                        title: '公章申请管理',
                        subs: [{
                                index: 'applyReason',
                                title: '公章申请理由管理',
                            },
                            {
                                icon: 'el-icon-lx-home',
                                index: 'sealArea',
                                title: '公章申请区域管理',
                            },

                        ]
                    },

                    {
                        icon: 'el-icon-bank-card',
                        title: '提现管理',
                        index: '5',
                        subs: [

                            {
                                index: 'userWithdrawal',
                                title: '员工提现审核'
                            }, {
                                index: 'finiceWithdrawal',
                                title: '财务公司提现审核'
                            },

                        ]
                    }, {
                        icon: 'el-icon-monitor',
                        index: '6',
                        title: '轮播图管理',
                        subs: [{
                            index: 'advertPosition',
                            title: '首页轮播图'
                        }, {
                            index: 'advert',
                            title: '订单页轮播图'
                        }]
                    },
                    {
                        icon: 'el-icon-document-checked',
                        index: 'sealApply',
                        title: '订单管理',
                    },
                    {
                        icon: 'el-icon-office-building',
                        index: 'financeCompany',
                        title: '财务公司'
                    },
                    {
                        icon: 'el-icon-setting',
                        title: '设置',
                        index: 'install'
                    },
                    {
                        icon: 'el-icon-user',
                        title: '员工账号',
                        index: 'empaccount'
                    },

                ]
            };
        },
        computed: {
            onRoutes() {
                return this.$route.path.replace('/', '');
            }
        },
        created() {

            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
                bus.$emit('collapse-content', msg);
            });
            // backstage/Chaptertrear/delunread 
            this.roleid = sessionStorage.getItem('roleid')
            this.companyid = sessionStorage.getItem('companyid')
            let formData = new FormData()
            formData.append("company_id", this.companyid)
            post("backstage/Chaptertrear/selunread", formData).then(res => {

                this.$store.commit('setIsActive', res.data.data.unread)
            })
        }
    };
</script>

<style scoped>
    .sidebar {
        display: block;
        position: absolute;
        left: 0;
        top: 70px;
        bottom: 0;
        overflow-y: scroll;
    }

    .sidebar::-webkit-scrollbar {
        width: 0;
    }

    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 180px;
    }

    .sidebar>ul {
        height: 100%;
    }

    .dot {
        color: white;
        background: red;
        width: auto;
        padding: 5px;
        height: auto;
        display: inline-block;
        margin-left: 20px;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        border-radius: 50%;
        border: 2px solid white;
        box-sizing: border-box;
    }
</style>